module.exports = __webpack_public_path__ + "img/mb-google-business-1.046884d1.jpg";